import { render, staticRenderFns } from "./classDetailBox.vue?vue&type=template&id=c7575d02"
import script from "./classDetailBox.vue?vue&type=script&lang=js"
export * from "./classDetailBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports